export default {
  AUTH0_DOMAIN: "leadernaplatform.eu.auth0.com",
  AUTH0_CLIENT_ID: "e8QfSXlsLISzTZ3htckL0J5doytNSqlt",
};
